import { render } from "./KdpAgree.vue?vue&type=template&id=3c9bba2e&scoped=true"
import script from "./KdpAgree.vue?vue&type=script&lang=js"
export * from "./KdpAgree.vue?vue&type=script&lang=js"

import "./KdpAgree.vue?vue&type=style&index=0&id=3c9bba2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c9bba2e"]])

export default __exports__